import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { ToastModule } from '../toast/index';

import { DisabledDirective } from './directives/disabled.directive';
import { PortalDirective } from './directives/portal.directive';
import { ResizeDirective } from './directives/resize.directive';
import { TextColorDirective } from './directives/text-color.directive';

export { DisabledDirective } from './directives/disabled.directive';
export { PortalDirective } from './directives/portal.directive';
export { ResizeDirective } from './directives/resize.directive';
export { TextColorDirective } from './directives/text-color.directive';

export { BaseModel, Resource, RequestParams, RequestMethod, ResourceParams, ResourcePromise, ResourceResponse, RequestInterceptor, ResponseInterceptor } from './base/model';
export { BaseEnum, EnumeratorData } from './base/enum';

@NgModule({
  declarations: [
    DisabledDirective,
    PortalDirective,
    ResizeDirective,
    TextColorDirective
  ],
  imports: [
    CommonModule,
    HttpClientModule,

    ToastModule
  ],
  exports: [
    DisabledDirective,
    PortalDirective,
    ResizeDirective,
    TextColorDirective
  ]
})
export class GenericModule { }
